import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster
        position="top-center"
        theme="light"
        richColors={false}
        closeButton
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-[hsl(var(--brand-champagne-gold))]/50 group-[.toaster]:shadow-[0_14px_40px_rgba(20,16,12,0.14)] group-[.toaster]:rounded-2xl group-[.toaster]:font-[var(--font-body)]",
            title: "group-[.toast]:font-semibold",
            description: "group-[.toast]:text-muted-foreground",
            success: "group-[.toaster]:border-[hsl(var(--brand-champagne-gold))]",
            error: "group-[.toaster]:border-[hsl(var(--destructive))]/60",
            closeButton:
              "group-[.toast]:bg-card group-[.toast]:border-border group-[.toast]:text-foreground",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
